"use client";
import { jsx as r } from "react/jsx-runtime";
import { InkeepShadow as t } from "@inkeep/cxkit-primitives";
import e from "../inkeep.css.js";
const i = (o) => /* @__PURE__ */ r(t, { styles: e, ...o });
export {
  i as Shadow
};
